var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.loading ? _c('div', {
    staticClass: "bcg-loading"
  }, [_c('v-progress-circular', {
    staticClass: "loading-spinner",
    attrs: {
      "indeterminate": ""
    }
  })], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }